import { IGenericBreadcrumbFilter } from '../common/breadcrumb-filter/models/IGenericBreadcrumbFilter';

export class BoCommonFilters {
    agent?: IGenericBreadcrumbFilter[];
    agencyBranch?: IGenericBreadcrumbFilter[];
    channels?: IGenericBreadcrumbFilter[];
    virtualAgencies?: IGenericBreadcrumbFilter[];
}
